import PropTypes from 'prop-types';
import seatPropType from './seat';

export default PropTypes.arrayOf(seatPropType);
